"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("@src/app/commons/Constants");
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/interfaces/identity');
/*
  Create an identity for any service / helper / controller / whatever
*/
class XsIdentityInterface {
    constructor() {
        this.__ID = null;
    }
    static __log(i, funcy = '??', data = '') {
        if (XsIdentityInterface.debug) {
            console.log('%c __IDENTITY %c ' + funcy + ' %c ' + i.id + ' ', Constants_1.Constants._red, Constants_1.Constants._black, Constants_1.Constants._gray, data);
        }
    }
    static __init(me, doIntrospection = true) {
        // already there?
        if (me.__ID) {
            console.error('Trying to re-identify an already identified class', me.__ID);
            return me.__ID;
        }
        // our new identity
        let i = {
            __xs: true,
            id: null,
            instance: XsIdentityInterface.__uuid(),
            idx: Object.keys(XsIdentityInterface.__registry).length - 1,
            class: me.constructor.name,
            type: typeof me,
            introspection: null,
            introspectionReady: false,
            anyEventHooks: false
        };
        if (doIntrospection) {
            i.introspection = XsIdentityInterface.__crawl(me);
            i.introspectionReady = true;
        }
        if (me.id) {
            i.id = i.class + '__' + me.id;
        }
        else {
            i.id = i.class + '__' + i.instance;
        }
        XsIdentityInterface.__registry[i.instance] = i;
        XsIdentityInterface.__registry._by_idx.push(i);
        XsIdentityInterface.__registry._class_list[i.instance] = i.class;
        setTimeout(() => { XsIdentityInterface.__init_delayed(me); }, 50);
        XsIdentityInterface.__log(i, 'init()');
        return i;
    }
    static __init_delayed(me) {
        let i = me.__ID;
        if (me.id) {
            i.id = i.class + '__' + me.id;
        }
        if (i.introspectionReady) {
            // console.log('Got any hooks?');
            i.anyEventHooks = XsIdentityInterface.__any_hooks(i.introspection);
            if (i.anyEventHooks && !me.__EVENTS) {
                console.error('Got hooks, but no __EVENTS to go to ...', i);
            }
            else if (i.anyEventHooks && !me.applicationEvents) {
                console.error('Got hooks, but no applicationEvents to use them with ...', i);
            }
        }
        // update registry and me
        XsIdentityInterface.__registry[i.instance] = i;
        me.__ID = i;
        // XsIdentityInterface.__log ( i, 'init_delayed()', i );
    }
    static __uuid(token = '_', prefix = 'uuid_') {
        return (prefix + 'xxxxxxxx' + token + 'xxxx' + token + '4xxx' + token + 'yxxx' + token + 'xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static __any_hooks(list = []) {
        for (let n = 0; n < list.length; n++) {
            if (list[n].substring(0, 3) == '___') {
                return true;
            }
        }
        return false;
    }
    static __check_all_props(obj = {}, list = []) {
        let res = [];
        list.forEach(p => {
            if (obj) {
                if (obj.hasOwnProperty(p)) {
                    const t = typeof obj[p];
                    let v = t == 'bigint' || t == 'boolean' || t == 'number' || t == 'string' || t == 'symbol' ? '"' + obj[p] + '"' : '';
                    if (t == 'object' && obj[p]) {
                        v = obj[p].constructor ? obj[p].constructor.name + ' class' : 'Object';
                    }
                    res.push(p + ' = ' + v + ' (' + t + ')');
                }
                else if (obj[p]) {
                    const t = typeof obj[p];
                    res.push(p + '() ' + t);
                }
                else {
                    res.push(p + ' undefined');
                }
            }
            else {
                res.push(p + ' : obj undefined');
            }
        });
        return res;
    }
    static __crawl(obj) {
        const original = obj;
        let aPropertiesAndMethods = [];
        let hooks = false;
        do {
            aPropertiesAndMethods = aPropertiesAndMethods.concat(Object.getOwnPropertyNames(obj));
        } while (obj = Object.getPrototypeOf(obj));
        for (var a = 0; a < aPropertiesAndMethods.length; ++a) {
            for (var b = a + 1; b < aPropertiesAndMethods.length; ++b) {
                if (aPropertiesAndMethods[a] === aPropertiesAndMethods[b]) {
                    aPropertiesAndMethods.splice(a--, 1);
                }
            }
        }
        return XsIdentityInterface.__check_all_props(original, aPropertiesAndMethods);
    }
}
XsIdentityInterface.debug = Constants_1.Constants.debug_off;
XsIdentityInterface.__registry = {
    _by_idx: [],
    _class_list: {}
};
exports.XsIdentityInterface = XsIdentityInterface;
